import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class LoungesService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('loungesrestaurant/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('loungesrestaurant/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('loungesrestaurant/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('loungesrestaurant/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('loungesrestaurant/update/save', data);
  }

  updateTables(val_id: number, data: any) {
    return this.restService.update('loungesrestaurant/update_tables', val_id, data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('loungesrestaurant/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('loungesrestaurant/delete', val_id);
  }
}
